import { CopyButton } from '@/components/common/CopyButton';
import { MonoChip } from '@/features/agents/components/MonoChip';

/**
 * Once-only webhook URL reveal (design §14.1/§17.4, Q1 resolved at T6): the
 * POST /triggers response carries `webhookUrl` and the GET list never re-exposes
 * it, and the backend mints no signing secret on this path — so the panel shows
 * the URL with CopyButton and drops the secret line (secret stays in
 * communication's webhook admin). Mirrors the API-key once-only pattern.
 */
export function WebhookRevealPanel({ urls }: { urls: string[] }) {
  if (urls.length === 0) {
    return null;
  }
  return (
    <div className="space-y-2 rounded-lg border bg-card p-4">
      <p className="text-sm font-medium">Webhook URLs</p>
      <ul className="space-y-2">
        {urls.map((url, index) => (
          <li key={`${url}-${index}`} className="flex flex-wrap items-center gap-2">
            <MonoChip className="min-w-0 flex-1">{url}</MonoChip>
            <CopyButton value={url} label="Copy webhook URL" size="sm" />
          </li>
        ))}
      </ul>
      <p className="text-sm text-muted-foreground">Store the URL now — it won't be shown again.</p>
    </div>
  );
}
